import { Navigate, Outlet } from "react-router-dom";

const ParticipantPrivate = () => {
  const data = sessionStorage.getItem("participant_role");

  return data ? (
    <Outlet />
  ) : (
    <Navigate to={`/signIn/${window.location.href.split("/").pop()}`} />
  );
};

export default ParticipantPrivate;
